const Industries = [
  {
    id: 1,
    value: "Aerospace",
    backendValue: "Aerospace",
  },
  {
    id: 2,
    value: "Agriculture",
    backendValue: "Agriculture",
  },
  {
    id: 3,
    value: "Arts and Entertainment",
    backendValue: "Arts and Entertainment",
  },
  {
    id: 4,
    value: "Automotive",
    backendValue: "Automotive",
  },
  {
    id: 5,
    value: "Beauty and Fitness",
    backendValue: "Beauty and Fitness",
  },
  {
    id: 6,
    value: "Books and Literature",
    backendValue: "Books and Literature",
  },
  {
    id: 7,
    value: "Chemical / Pharmaceutiacals",
    backendValue: "Chemical / Pharmaceuticals",
  },
  {
    id: 8,
    value: "Computers and Electronics",
    backendValue: "Computers and Electronics",
  },
  {
    id: 9,
    value: "Construction",
    backendValue: "Construction",
  },
  {
    id: 10,
    value: "Defence",
    backendValue: "Defence",
  },
  {
    id: 11,
    value: "Energy",
    backendValue: "Energy",
  },
  {
    id: 12,
    value: "Finance",
    backendValue: "Finance",
  },
  {
    id: 13,
    value: "Food and Drink",
    backendValue: "Food and Drink",
  },
  {
    id: 14,
    value: "Games",
    backendValue: "Games",
  },
  {
    id: 15,
    value: "Healthcare",
    backendValue: "Healthcare",
  },
  {
    id: 16,
    value: "Hobbies and Leisure",
    backendValue: "Hobbies and Leisure",
  },
  {
    id: 17,
    value: "Home and Garden",
    backendValue: "Home and Garden",
  },
  {
    id: 18,
    value: "Hospitality",
    backendValue: "Hospitality",
  },
  {
    id: 19,
    value: "Internet and Telecom",
    backendValue: "Internet and Telecom",
  },
  {
    id: 20,
    value: "Jobs and Education",
    backendValue: "Jobs and Education",
  },
  {
    id: 21,
    value: "Law and Government",
    backendValue: "Law and Government",
  },
  {
    id: 22,
    value: "Manufacturing",
    backendValue: "Manufacturing",
  },
  {
    id: 23,
    value: "Media",
    backendValue: "Media",
  },
  {
    id: 24,
    value: "People and Society",
    backendValue: "People and Society",
  },
  {
    id: 25,
    value: "Pets and Animals",
    backendValue: "Pets and Animals",
  },
  {
    id: 26,
    value: "Professional Services",
    backendValue: "Professional Services",
  },
  {
    id: 27,
    value: "Real Estate",
    backendValue: "Real Estate",
  },
  {
    id: 28,
    value: "Retail",
    backendValue: "Retail",
  },
  {
    id: 29,
    value: "Science",
    backendValue: "Science",
  },
  {
    id: 30,
    value: "Shopping",
    backendValue: "Shopping",
  },
  {
    id: 31,
    value: "Software",
    backendValue: "Software",
  },
  {
    id: 32,
    value: "Sports",
    backendValue: "Sports",
  },
  {
    id: 33,
    value: "Travel",
    backendValue: "Travel",
  },
];

export default Industries;
